import React from 'react';
import { motion } from 'framer-motion';
export const Guarantee: React.FC = () => {
  return <section className="py-20 px-4 bg-brand-charcoal text-white relative overflow-hidden" data-id="element-82">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-gold via-transparent to-transparent" data-id="element-83"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-84">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="w-40 h-40 mx-auto mb-8 bg-brand-gold rounded-full flex items-center justify-center p-2 border-4 border-brand-goldDark shadow-[0_0_40px_rgba(201,169,97,0.4)]" data-id="element-85">
          <div className="w-full h-full border-2 border-dashed border-brand-wine rounded-full flex flex-col items-center justify-center text-brand-wine bg-brand-cream" data-id="element-86">
            <span className="font-serif font-bold text-3xl leading-none" data-id="element-87">
              60
            </span>
            <span className="font-bold text-sm tracking-widest" data-id="element-88">DÍAS</span>
            <span className="text-[10px] uppercase font-bold mt-1" data-id="element-89">
              Garantía
            </span>
          </div>
        </motion.div>

        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-brand-gold" data-id="element-90">
          GARANTÍA TOTAL DE 60 DÍAS
        </h2>
        <h3 className="text-2xl font-serif italic mb-10" data-id="element-91">“ÁMALO O DÉJALO”</h3>

        <div className="text-lg text-gray-300 space-y-6 max-w-2xl mx-auto text-left" data-id="element-92">
          <p data-id="element-93">Odio las garantías falsas.</p>
          <p data-id="element-94">Así que voy a hacer esto simple.</p>
          <p className="font-bold text-white" data-id="element-95">
            Prueba la guía por 60 días completos.
          </p>
          <p data-id="element-96">Si no sientes que:</p>
          <ul className="list-disc pl-6 space-y-2 text-white" data-id="element-97">
            <li data-id="element-98">entiendes mejor las dinámicas emocionales</li>
            <li data-id="element-99">te sientes más tranquila</li>
            <li data-id="element-100">recuperaste claridad</li>
            <li data-id="element-101">dejaste de perseguir emocionalmente</li>
          </ul>
          <p className="pt-4" data-id="element-102">
            Simplemente envíanos un email y te devolveremos el 100% de tu
            dinero.
          </p>
          <p className="font-bold text-brand-gold" data-id="element-103">
            Sin preguntas. Sin drama. Sin letras pequeñas.
          </p>
        </div>
      </div>
    </section>;
};